import { ArrowNarrowLeftIcon, ArrowNarrowRightIcon } from 'assets/icons';
import styles from './memory-pager.module.scss';

interface MemoryPagerProps {
  index: number;
  total: number;
  // What is being walked through: the album's name, or "All memories".
  title: string;
  onPrev: () => void;
  onNext: () => void;
}

// The phone screen's bar at the bottom, as in the mobile app: the previous
// and next memory, and where this one is.
export const MemoryPager = ({
  index,
  total,
  title,
  onPrev,
  onNext,
}: MemoryPagerProps) => (
  <nav className={styles.pager} aria-label="Memories">
    <button
      type="button"
      className={styles.button}
      aria-label="Previous memory"
      disabled={index === 0}
      onClick={onPrev}
    >
      <ArrowNarrowLeftIcon />
    </button>
    <div className={styles.label}>
      <span className={styles.count}>
        {index + 1} of {total}
      </span>
      {title && <span className={styles.title}>{title}</span>}
    </div>
    <button
      type="button"
      className={styles.button}
      aria-label="Next memory"
      disabled={index === total - 1}
      onClick={onNext}
    >
      <ArrowNarrowRightIcon />
    </button>
  </nav>
);
